export const parseBackendError = (response: any) => {
    return response?.message ?? 'Ha ocurrido un error desconocido. Por favor, intenta nuevamente!'
}